import { Navigate } from "react-router";

import { LoadingState } from "@/components/common";
import { useMe } from "@/lib/api";
import { logger } from "@/lib/logger";

import { LeadershipReportPage } from "./leadership-report-page";

/**
 * The Leadership report's gate: only people on `LEADERSHIP_REPORT_VIEWERS`
 * (`/auth/me` → `leadership_report`). Everyone else, other admins included,
 * goes home; the server refuses them anyway (403).
 */
export function LeadershipReportRoute() {
  const { data: me, isLoading } = useMe();
  if (isLoading) {
    return <LoadingState description={null} />;
  }
  if (me?.leadership_report !== true) {
    logger.debug("[auth] not a Leadership report viewer; leaving");
    return <Navigate to="/home" replace />;
  }
  return <LeadershipReportPage />;
}
